// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__UhYOp","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2m2cz","obliqueLine":"membershipbadge_obliqueLine__1x3GE"};